import { zonesNormalize } from '../zones/zonesNormalize';
/** Filter an array x/y based on various criteria x points are expected to be sorted
 *
 * @param data - points
 * @param options - options
 * @return filtered array
 */
export function xyFilterX(data, options = {}) {
    const { x, y } = data;
    const { from = x[0], to = x[x.length - 1], zones = [{ from, to }], exclusions = [], } = options;
    let normalizedZones = zonesNormalize(zones, { from, to, exclusions });
    let currentZoneIndex = 0;
    let newX = [];
    let newY = [];
    let position = 0;
    while (position < x.length) {
        if (x[position] <= normalizedZones[currentZoneIndex].to &&
            x[position] >= normalizedZones[currentZoneIndex].from) {
            newX.push(x[position]);
            newY.push(y[position]);
        }
        else {
            if (x[position] > normalizedZones[currentZoneIndex].to) {
                currentZoneIndex++;
                if (!normalizedZones[currentZoneIndex])
                    break;
            }
        }
        position++;
    }
    return {
        x: newX,
        y: newY,
    };
}
//# sourceMappingURL=xyFilterX.js.map